import { connect } from "react-redux";
import CreditPolicy from "./creditPolicy";
import { bindActionCreators } from "redux";
import {
    creditListing, teamListing
} from "services/redux/creditPolicy/action";

const mapStateToProps = (state) => ({
    creditsList: state.creditPolicyReducer.creditsList,
    teamsList: state.creditPolicyReducer.teamsList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      creditListing,
      teamListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreditPolicy);
